import Doctorocs from '@components/brand/doctorcos'
import React from 'react'

const DoctorcosPage = () => {
  return <Doctorocs />
}
export default DoctorcosPage
